import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { viewerSurfacesAtom } from "../atoms/viewerSurfacesAtom";
import type { Surface } from "../constants/viewerActions";
import { caseViewerSurfaces } from "../utils/viewerSurfaces";

/**
 * CaseViewer's viewer surfaces: its host's base surfaces plus prediction-masks
 * while the AI mask toggle is available. Reset to null on unmount.
 */
export function useCaseViewerSurfaces(base: readonly Surface[], predictionMasks: boolean): void {
  const setViewerSurfaces = useSetAtom(viewerSurfacesAtom);
  useEffect(() => {
    setViewerSurfaces(caseViewerSurfaces(base, predictionMasks));
    return () => setViewerSurfaces(null);
  }, [base, predictionMasks, setViewerSurfaces]);
}

/**
 * LabelingPage's viewer surfaces. Skipped while the hosted CaseViewer owns them
 * (factory / study routes): it mounts later, so a second writer here would race
 * it — and the loser used to be labeling-seg (ENG-250).
 */
export function useLabelingViewerSurfaces(
  surfaces: readonly Surface[],
  ownedByCaseViewer: boolean,
): void {
  const setViewerSurfaces = useSetAtom(viewerSurfacesAtom);
  useEffect(() => {
    if (ownedByCaseViewer) return;
    setViewerSurfaces([...surfaces]);
    return () => setViewerSurfaces(null);
  }, [surfaces, ownedByCaseViewer, setViewerSurfaces]);
}
